import { render, staticRenderFns } from "./price-reduction-renewal.vue?vue&type=template&id=3a69ca76&scoped=true&lang=pug&"
import script from "./price-reduction-renewal.vue?vue&type=script&lang=js&"
export * from "./price-reduction-renewal.vue?vue&type=script&lang=js&"
import style0 from "./price-reduction-renewal.vue?vue&type=style&index=0&id=3a69ca76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a69ca76",
  null
  
)

export default component.exports